<template>
  <div class="mb-6">
    <label class="block pb-px">
      <span class="text-gray-700">{{ title }}</span>
      <select v-bind="$attrs"
              class="form-select block w-full mt-1"
              @change="$emit('input', $event.target.value)">
        <option></option>
        <option v-for="option in options"
                :key="option.value"
                :value="option.value">{{ option.text }}</option>
      </select>
    </label>
    <div v-for="(value, key) in checkboxes"
         :key="key"
         class="mt-1">
      <label class="flex items-center">
        <input type="radio"
               class="form-radio"
               @change="$emit('input', $event.target.checked ? key : undefined)"
               :checked="$attrs.value == key">
        <span class="ml-2">{{ value }}</span>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,

  props: {
    title: String,
    options: Array,
    checkboxes: Object
  }
};
</script>
